export const volumes = [
  {
    number: "01",
    topic: "Preparación",
    title: "Tu punto de partida",
    text: "Qué necesitas antes de vender: espacio, herramientas, higiene y cómo elegir tus productos estrella.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/c7a34e33-e2a7-4416-a47a-1f94b666bc8a.jpg",
    imageAlt: "Mesada de cocina organizada con bowls, balanza, batidor y cuaderno",
  },
  {
    number: "02",
    topic: "Recetas",
    title: "Recetas que se venden",
    text: "Brownies, cookies, alfajores y más, con cantidades y rendimientos pensados para repetir siempre igual.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/ca1a54ce-a160-48a1-b679-5ae8ba5f130b.jpg",
    imageAlt: "Brownies, cookies y alfajores junto a un cuaderno de recetas",
  },
  {
    number: "03",
    topic: "Costos",
    title: "Cuánto cobrar",
    text: "Calcula ingredientes, packaging y tiempo. Define precios que cuiden tu bolsillo, en tu propia moneda.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/d4e68202-51ad-43c1-adf9-3644d4973e1b.jpg",
    imageAlt: "Calculadora, cuaderno con números e ingredientes sobre la mesa",
  },
  {
    number: "04",
    topic: "Instagram",
    title: "Tu vidriera digital",
    text: "Arma un perfil profesional, saca buenas fotos con el celular y aprende qué publicar cada semana.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/46271acd-8e14-4e20-8172-264278a6f420.jpg",
    imageAlt: "Manos fotografiando una torta de chocolate con el celular",
  },
  {
    number: "05",
    topic: "WhatsApp",
    title: "Vender por chat",
    text: "Catálogo, respuestas rápidas y una forma clara de tomar pedidos, cobrar y confirmar entregas.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/847c030f-ad3e-44c0-9c9b-eaa36a3bb5c7.jpg",
    imageAlt: "Celular con un chat abierto junto a una caja de cookies",
  },
  {
    number: "06",
    topic: "Organización",
    title: "Pedidos en orden",
    text: "Planifica tu producción, agenda entregas y lleva el control de cobros sin estrés.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/cebc77ff-f18c-40bd-9d32-34c2134f039e.jpg",
    imageAlt: "Cajas kraft listas para entregar y una agenda de pedidos",
  },
];
